<template>
  <v-row>
    <v-col class="text-center">
      <v-btn class="ma-2" tile outlined color="primary" @click="save(path)">
        <v-icon left>settings</v-icon>{{$t('DeviceTypes.save')}}
      </v-btn>
    </v-col>
    <v-col class="text-center">
      <v-btn class="ma-2" tile outlined color="primary" @click="$emit('back')">
        <v-icon left>mdi-arrow-left</v-icon>{{$t('DeviceTypes.back')}}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  props: {
    path: String,
    deviceTypeToCreate: Object,
    deviceTypeToUpdate: Object,
    deviceTypeId: String
  },
  methods: {
    save: function(path) {
      switch (path) {
        case "create":
          if (this.deviceTypeToCreate.valid) {
            axios
              .post(
                process.env.VUE_APP_API_ADDR + "/api/deviceType",
                this.deviceTypeToCreate,
                {
                  headers: { Authorization: tokenStore.getToken() }
                }
              )
              .then(res => {
                if (res.data.success) {
                  this.$emit("saved", this.$t('DeviceTypes.Alert.success-create'));
                }
              })
              .catch(err => {
                this.$emit("error", err.response.data.errorMessage);
              });
          } else {
            this.$emit("error", this.$t('DeviceTypes.Alert.form-error'));
          }
          break;
        case "edit":
          if (this.deviceTypeToUpdate.valid) {
            axios
              .put(
                process.env.VUE_APP_API_ADDR + "/api/devicetype/" + this.deviceTypeId,
                this.deviceTypeToUpdate,
                {
                  headers: { Authorization: tokenStore.getToken() }
                }
              )
              .then(res => {
                if (res.data.success) {
                  this.$emit("saved",this.$t('DeviceTypes.Alert.success-update'));
                }
              })
              .catch(err => {
                this.$emit("error", err.response.data.errorMessage);
              });
          } else {
            this.$emit("error", this.$t('DeviceTypes.Alert.form-error'));
          }
          break;
      }
    }
  }
};
</script>


